import { createFileRoute } from "@tanstack/react-router";
import { ProgramPartnerskiFormPage } from "@/features/sys-premiowy/program-partnerski-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/system-premiowy/program-partnerski/$id")({
	component: ProgramPartnerskiFormPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-program-partnerski",
			location.pathname,
		);
	},
});
